<template>
    <div class="LocationList" style="display:flex;flex-direction:column; max-height:85vh;">
        <h2>Care Communities <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.ProgramRegions" @change="RefreshDataTable">
                            <option v-for="option in SubProgramRegionOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Status:</label>
                        <select class="form-control" v-model="Filters.IsActive" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="True">Active</option>
                            <option value="False">Inactive</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfLocations}} Records
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search List:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </form>
        <div style="overflow:auto;">
            <vuetable :fields="LocationsTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="locationslistdatatableid">

                <template slot="LocationRecordName" scope="props">
                    <div class="LocationRecordName">
                        <span class="underline pointer" @click="OpenCareCommunityRecord(props.rowData.Id, props.rowData)" v-html="props.rowData.Name"></span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        name: "LocationList",
        props: [],
        data: function () {
            return {
                search: "",
                NumberOfLocations: '',
                Filters: {
                    ProgramRegions: "",
                    IsActive: 'True'
                },

                LocationsTableOptions: {
                    Fields: [
                        {
                            name: '__slot:LocationRecordName',
                            title: 'Name',
                            sortField: 'Name',
                        },
                        {
                            name: 'TeamLeaderName',
                            title: 'Team Leader',
                            sortField: 'TeamLeaderName'
                        },
                        {
                            name: 'Region',
                            title: 'Region',
                            sortField: 'Region'
                        },
                        {
                            name: 'Address.AddressLine1',
                            title: 'Address',
                            sortField: 'Address.AddressLine1'
                        },
                        {
                            name: 'Address.AddressLine2',
                            title: 'Unit',
                            sortField: 'Address.AddressLine2'
                        },
                        {
                            name: 'Address.City',
                            title: 'City',
                            sortField: 'Address.City'
                        },
                        {
                            name: 'Address.ZipCode',
                            title: 'ZipCode',
                            sortField: 'Address.ZipCode'
                        },
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetCareCommunities();
            },
            GetCareCommunities() {
                // Use Master API to call GetResidencesForSubProgram endpoint
                this.$MasterAPI.ExecuteRequest("GET", 'Foster/CareCommunity/CareCommunityList',
                    {
                        IsActive: this.Filters.IsActive,
                        ProgramRegions: this.Filters.ProgramRegions,
                    }, this.GetCareCommunitiesSuccess, () => { }, true
                )
            },
            GetCareCommunitiesSuccess(response) {
                this.$store.commit("CareCommunities.CareCommunityList.ReplaceListOnly", response.data.data);
                this.$refs.datatable.refresh();
            },
            // Adds the location record in the LocationPane component
            OpenCareCommunityRecord(CommunityCareID, CareCommunityRecordData) {
                // Append team data to team profiles
                this.$store.commit("CareCommunities.CareCommunityProfiles.Append", CareCommunityRecordData);
                // Change pane
                this.$parent.ChangePaneShown(CommunityCareID);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.CareCommunities);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfLocations = visibleData.length;
                return visibleData;
            },
        },

        components: {
            Vuetable,
            EventBus
        },

        computed: {
            CareCommunities: function () {
                // gets the Client Enrollment List from the store
                return this.$store.state.CareCommunities.CareCommunityList;
            },
            ProgramRegions: function () {
                return this.$store.state.Options.ProgramRegions;
            },
            SubProgramRegionOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramRegionOptions"]();
            },
        },

        mounted() {
            var vm = this;
            //Get Location Records*/
            this.Filters.ProgramRegions = this.ProgramRegions[0].value;
            this.GetCareCommunities();

            let getCareCommunitiesFunc = function () {
                vm.GetCareCommunities();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getCareCommunitiesFunc);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>